(function () {
  'use strict';

  var section = document.querySelector('.tp-product-hero');
  if (!section) return;

  var variantInput = document.getElementById('tpVariantIdInput');
  var priceEl = document.getElementById('tpBuyBoxPrice');
  var qtyInput = document.getElementById('tpQtyValue');
  var qtyMinus = document.getElementById('tpQtyMinus');
  var qtyPlus = document.getElementById('tpQtyPlus');
  var qtyWrap = section.querySelector('.tp-quantity-selector');
  var addBtn = document.getElementById('tpAddToCartBtn');
  var miniAddBtn = document.getElementById('tpMiniAddBtn');
  var buyNowBtn = document.getElementById('tpBuyNowBtn');
  var buyNowError = document.getElementById('tpBuyNowError');
  var buyNowAvail = buyNowBtn ? !buyNowBtn.disabled : false;
  var liveTotal = document.getElementById('tpBuyBoxTotal');
  var addLive = document.getElementById('tpAddLive');
  var stickyBar = document.getElementById('tpMobileStickyBar');
  var stickyBtn = document.getElementById('tpMobileStickyAddBtn');
  var stickyPrice = document.getElementById('tpMobileStickyPrice');
  var stickyQty = document.getElementById('tpMobileStickyQty');
  var gallery = section.querySelector('[data-tp-gallery]');
  var galleryMain = document.getElementById('tpGalleryMain');
  var galleryThumbs = document.getElementById('tpGalleryThumbs');
  var galleryPrev = document.getElementById('tpGalleryPrevBtn');
  var galleryNext = document.getElementById('tpGalleryNextBtn');
  var form = document.getElementById('tpProductForm');
  var currentPriceCents = parseInt(section.dataset.defaultPriceCents, 10) || 0;
  var stickyShownCents = currentPriceCents;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var moneyFormat = section.dataset.moneyFormat || '';
  var defaultHeroId = gallery ? String(gallery.dataset.defaultHero || '') : '';
  /* Carte des economies : relue des que le noeud #tpSavingsJson n'est plus le
     meme (buybox re-rendue / remplacee), sinon servie depuis le cache. */
  var savingsNode = null, savingsMap = {};
  function readSavingsMap() {
    var node = document.getElementById('tpSavingsJson');
    if (node !== savingsNode) {
      savingsNode = node;
      try { savingsMap = node ? (JSON.parse(node.textContent) || {}) : {}; } catch (e) { savingsMap = {}; }
    }
    return savingsMap;
  }
  readSavingsMap();

  /* ================= OFFRE « ACHETEZ 2 » =================
     Modes « legacy » (ancien multipack) et « duo » (2e couleur au choix).
     Cle de paire TOUJOURS canonique (IDs source tries numeriquement) ;
     l'ordre visuel (exemplaire 1 = couleur principale, exemplaire 2 = couleur
     choisie) en est independant. Variantes duo d'ordre inverse jamais utilisees.
     duoColor2Manual : tant qu'aucun choix manuel, couleur 2 suit couleur 1.
     IMAGES : data-tp-x2-img="1" est porte par PLUSIEURS elements (miniature
     « 1 unite » + avant du duo) -> querySelectorAll obligatoire. */
  var x2 = section.querySelector('[data-tp-x2]');
  var x2Mode = x2 ? (x2.dataset.mode || 'legacy') : '';
  var x2Map = {}, x2Images = {}, duoData = null;
  var duoColor2 = null, duoColor2Manual = false, duoGroups = null;
  var duoPicker = null, duoSwatches = null, duoSummary = null, duoError = null;
  if (x2) {
    var mapNode = x2.querySelector('[data-tp-x2-map]');
    if (mapNode) { try { x2Map = JSON.parse(mapNode.textContent) || {}; } catch (e) { x2Map = {}; } }
    var imgNode = x2.querySelector('[data-tp-x2-images]');
    if (imgNode) { try { x2Images = JSON.parse(imgNode.textContent) || {}; } catch (e) { x2Images = {}; } }
    var duoNode = x2.querySelector('[data-tp-x2-duo]');
    if (duoNode) { try { duoData = JSON.parse(duoNode.textContent); } catch (e) { duoData = null; } }
    var duoGroupsNode = x2.querySelector('[data-tp-x2-duo-groups]');
    if (duoGroupsNode) { try { duoGroups = JSON.parse(duoGroupsNode.textContent); } catch (e) { duoGroups = null; } }
    duoPicker = x2.querySelector('[data-tp-x2-picker]');
    duoSwatches = x2.querySelector('[data-tp-x2-swatches]');
    duoSummary = x2.querySelector('[data-tp-x2-summary]');
    duoError = x2.querySelector('[data-tp-x2-error]');
  }
  /* Teinte des pastilles duo : champ « hex » du JSON rendu par le Liquid (palette unique : snippet toudoupet-color-swatch). */
  function shortLabel(label) { var p = String(label).split('— '); return p.length > 1 ? p[p.length - 1] : label; }

  function currentVariantId() { return variantInput ? String(variantInput.value || '') : ''; }
  function currentLabel() {
    if (!duoData) return '';
    var id = currentVariantId();
    var o = duoData.options.find(function (x) { return String(x.v) === id; });
    return o ? o.l : '';
  }
  function pairKey(a, b) { var x = Number(a), y = Number(b); return (x <= y ? x + '|' + y : y + '|' + x); }
  function duoVariantFor(label2) {
    if (!duoData) return null;
    var o = duoData.options.find(function (x) { return x.l === label2; });
    if (!o) return null;
    var id = duoData.paires[pairKey(currentVariantId(), o.v)];
    if (!id) return null;
    return { id: id, price: duoData.prix, available: duoData.dispo.indexOf(id) !== -1, src2: o.v };
  }
  function packFor(variantId) { var e = x2Map[String(variantId)]; return (e && e.available !== false) ? e : null; }
  function packSelected() { var r = x2 ? x2.querySelector('[data-tp-x2-qty]:checked') : null; return !!(r && r.value === '2'); }
  function currentOffer() {
    if (!x2) return null;
    /* P3.1 : une paire duo epuisee n'est jamais une offre applicable (stock Shopify). */
    if (x2Mode === 'duo') { var duoRes = duoColor2 ? duoVariantFor(duoColor2) : null; return (duoRes && duoRes.available) ? duoRes : null; }
    return packFor(currentVariantId());
  }

  /* Offre trio 1/2/3 (toudoupet-offer-trio.js, moteur separe) : il publie
     l'offre cochee sur son fieldset (data-offer-units / data-offer-cents, vides
     en « 1 unite ») puis emet tp:offerchange. Affichee ici comme l'offre x2
     (total sous le CTA, barre mobile). trioKey = etat deja affiche. */
  var trio = section.querySelector('[data-tp-trio]');
  var trioKey = '';
  /* P3.5 : prix actuellement affiche dans la ligne de prix principale (centimes). */
  var mainShownCents = currentPriceCents;
  function trioOffer() {
    if (!trio) return null;
    trioKey = (trio.dataset.offerUnits || '') + ':' + (trio.dataset.offerCents || '');
    var units = parseInt(trio.dataset.offerUnits, 10), cents = parseInt(trio.dataset.offerCents, 10);
    return (units > 1 && cents > 0) ? { price: cents, units: units } : null;
  }

  var colorHeroes = null, colorIndex = -1;
  try { var colorNode = document.getElementById('tpColorHeroes'); if (colorNode) { colorHeroes = JSON.parse(colorNode.textContent) || null; colorIndex = parseInt(colorNode.dataset.colorIndex, 10); } } catch (e) { colorHeroes = null; }
  function colorHeroFor(values) { if (!colorHeroes || colorIndex < 0 || !values) return ''; var v = values[colorIndex]; return v && colorHeroes[v] ? String(colorHeroes[v]) : ''; }

  var FORMAT_RE = /\{\{\s*(\w+)\s*\}\}/;
  var THOUSANDS_RE = /\B(?=(\d{3})+(?!\d))/g;
  function formatMoneyFallback(cents) {
    var v = cents / 100; var m = moneyFormat.match(FORMAT_RE); var key = m ? m[1] : 'amount_with_comma_separator';
    var noDec = key.indexOf('no_decimals') !== -1; var thousands = ',', decimal = '.';
    if (key.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') !== -1) { thousands = ' '; decimal = ','; }
    var fixed = noDec ? Math.round(v).toString() : v.toFixed(2); var parts = fixed.split('.');
    var amount = parts[0].replace(THOUSANDS_RE, thousands) + (noDec ? '' : decimal + parts[1]);
    return m ? moneyFormat.replace(m[0], amount) : amount + ' €';
  }
  function priceText(cents) { return window.ToudouPrice ? window.ToudouPrice.text(cents) : formatMoneyFallback(cents); }
  function renderPrice(el, cents, klass) { if (!el) return; if (window.ToudouPrice) window.ToudouPrice.render(el, cents, { klass: klass }); else el.textContent = formatMoneyFallback(cents); }
  function rollPrice(el, fromCents, toCents) {
    if (!el) return;
    if (window.ToudouPrice && window.ToudouPrice.animate && !reduceMotion) window.ToudouPrice.animate(el, fromCents, toCents);
    else renderPrice(el, toCents);
  }
  function escapeHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function announce(message) { if (!addLive) return; addLive.textContent = ''; window.setTimeout(function () { addLive.textContent = message; }, 30); }

  /* P3.1 : offre de lot appliquee -> { price, units } ou null (achat a l'unite).
     Une offre = UNE ligne panier : la variante bundle Shopify (quantite 1) qui
     contient `units` exemplaires. Le selecteur de quantite affiche les unites. */
  function activeOffer() {
    if (packSelected()) { var o = currentOffer(); if (o) return { id: o.id, price: o.price, units: 2 }; }
    var t = trioOffer();
    return t ? { id: null, price: t.price, units: t.units } : null;
  }
  function updateLiveTotal(animateSticky) {
    var offer = activeOffer();
    var units = offer ? offer.units : 0;
    var packLabel = 'Pack de ' + units;
    var qty = qtyValue();
    var total, stickyTarget;
    if (offer) {
      /* Un seul lot : jamais multiplie par la quantite affichee (2 ou 3 unites). */
      total = offer.price;
      if (liveTotal) liveTotal.textContent = 'Total : ' + priceText(total) + ' — ' + packLabel + ' au lieu de ' + priceText(currentPriceCents * units);
      stickyTarget = total;
    } else {
      total = currentPriceCents * qty;
      if (liveTotal) liveTotal.textContent = qty > 1 ? 'Total : ' + priceText(total) + ' (' + qty + ' × ' + priceText(currentPriceCents) + ')' : '';
      stickyTarget = qty > 1 ? total : currentPriceCents;
    }
    if (animateSticky) rollPrice(stickyPrice, stickyShownCents, stickyTarget); else renderPrice(stickyPrice, stickyTarget);
    stickyShownCents = stickyTarget;
    if (stickyQty) { stickyQty.hidden = !(qty > 1 || offer); stickyQty.textContent = offer ? packLabel : (qty > 1 ? qty + ' articles' : ''); }
    /* P3.5 / P3.1 : offres x2 et trio -> le prix principal affiche le prix du
       lot applique (meme source que la barre mobile et le panier) ; a l'unite,
       prix unitaire de la variante. Reference barree = unites x prix unitaire. */
    if ((trio || x2) && priceEl) {
      var mainTarget = offer ? offer.price : currentPriceCents;
      if (mainTarget !== mainShownCents) {
        if (animateSticky) rollPrice(priceEl, mainShownCents, mainTarget); else renderPrice(priceEl, mainTarget);
        mainShownCents = mainTarget;
      }
      var offerTag = document.getElementById('tpBuyBoxPriceOffer');
      if (offerTag) {
        offerTag.hidden = !offer;
        offerTag.innerHTML = offer ? 'Lot de ' + units + ' <span class="tp-buy-box__price-offer-ref"><span class="tp-visually-hidden">au lieu de </span><s>' + escapeHtml(priceText(currentPriceCents * units)) + '</s></span>' : '';
      }
    }
    /* P3.1 : mention automatique tenue a jour (autre couleur / variante). */
    var autoN = offerBox() ? offerBox().querySelector('.tp-offer-auto') : null;
    if (autoN && !autoN.hidden) setAutoNote(true);
  }

  /* P3.1 : synchronisation quantite <-> offre. La quantite affichee (unites) est
     la reference : 2 -> Pack de 2 (x2 ou trio), 3 -> Pack de 3 (trio seulement),
     sinon achat a l'unite au prix unitaire (aucune remise inventee, jamais de
     decoupage silencieux en plusieurs lots). Offre indisponible -> unites au
     prix unitaire. auto=true : l'offre a ete choisie par la quantite -> mention
     visible sur la carte et annonce lecteur d'ecran. */
  function offerBox() { return x2 || trio || null; }
  function autoNote() {
    var box = offerBox(); if (!box) return null;
    var n = box.querySelector('.tp-offer-auto');
    if (!n) { n = document.createElement('p'); n.className = 'tp-offer-auto'; n.setAttribute('role', 'status'); n.hidden = true; box.appendChild(n); }
    return n;
  }
  function setAutoNote(show) {
    var n = autoNote(); if (!n) return;
    var offer = show ? activeOffer() : null;
    if (!offer) { n.hidden = true; n.textContent = ''; return; }
    n.textContent = 'Pack de ' + offer.units + ' appliqué automatiquement : ' + priceText(offer.price) + ' au lieu de ' + priceText(currentPriceCents * offer.units) + '.';
    n.hidden = false;
  }
  function syncOfferToQty(auto) {
    var q = qtyValue();
    var changed = false;
    if (x2) {
      var two = x2.querySelector('[data-tp-x2-qty][value="2"]');
      var one = x2.querySelector('[data-tp-x2-qty][value="1"]');
      var want2 = q === 2 && !!currentOffer();
      if (two && one && two.checked !== want2) {
        (want2 ? two : one).checked = true;
        refreshX2();
        x2.dispatchEvent(new CustomEvent('tp:offerchange', { bubbles: true, detail: { source: 'x2' } }));
        changed = true;
      }
    } else if (trio) {
      var curR = trio.querySelector('[data-tp-trio-offer]:checked');
      var cur = curR ? curR.value : '1';
      var want = (q === 2 || q === 3) ? String(q) : '1';
      var r = trio.querySelector('[data-tp-trio-offer][value="' + want + '"]');
      if (!r || r.disabled) { want = '1'; r = trio.querySelector('[data-tp-trio-offer][value="1"]'); }
      if (r && want !== cur) {
        r.checked = true;
        trio.dataset.tpSyncing = '1';
        try { r.dispatchEvent(new Event('change', { bubbles: true })); } finally { delete trio.dataset.tpSyncing; }
        changed = true;
      }
    }
    if (changed || !activeOffer()) setAutoNote(auto && !!activeOffer());
    return changed;
  }
  /* Quantite : la frappe n'est jamais reecrite (champ vide autorise pendant la
     saisie) ; valeur normalisee (entier >= 1) a la validation et avant l'ajout. */
  function qtyValue() { var v = parseInt(qtyInput && qtyInput.value, 10); return v >= 1 ? v : 1; }
  function normalizeQty() { if (qtyInput && qtyInput.value !== String(qtyValue())) qtyInput.value = qtyValue(); }
  function applyPrice(newCents) {
    var from = currentPriceCents;
    currentPriceCents = newCents;
    /* P3.5 : avec l'offre trio, la ligne de prix principale est rendue par
       updateLiveTotal (prix du lot coche ou prix unitaire). */
    if (!trio && !x2) { rollPrice(priceEl, from, newCents); mainShownCents = newCents; }
    refreshX2();
    syncOfferToQty(true);
    updateLiveTotal(true);
  }

  function renderSwatches() {
    syncDuoGroup();
    if (!duoSwatches || !duoData) return;
    var cur = currentLabel();
    duoSwatches.innerHTML = duoData.options.map(function (o) {
      var res = duoVariantFor(o.l);
      var ok = !!(res && res.available);
      var active = o.l === duoColor2;
      return '<button type="button" class="tp-x2__swatch' + (active ? ' is-active' : '') + (ok ? '' : ' is-unavailable') + '" aria-pressed="' + (active ? 'true' : 'false') + '"' + (ok ? '' : ' aria-disabled="true"') + ' data-tp-x2-color="' + escapeHtml(o.l) + '" style="--tp-swatch:' + escapeHtml(o.hex || '#A8A39B') + '"><span class="tp-x2__swatch-dot" aria-hidden="true"></span>' + escapeHtml(shortLabel(o.l)) + (ok ? '' : ' <span class="tp-visually-hidden">indisponible</span>') + '</button>';
    }).join('');
    if (duoSummary) duoSummary.innerHTML = 'Votre duo : <strong>' + escapeHtml(shortLabel(cur)) + ' + ' + escapeHtml(shortLabel(duoColor2 || cur)) + '</strong>';
  }
  /* Post-QA (12-10-2026) : la 2e couleur par defaut reste la meme que la 1re,
     sauf si ce duo est reellement indisponible (stock insuffisant pour 2 exemplaires
     identiques) : on propose alors la premiere couleur disponible, visible dans
     « Votre duo » et modifiable. Les combinaisons indisponibles restent marquees. */
  /* Post-QA (12-10-2026) : la fiche peut changer de capacite sans rechargement ;
     on bascule alors sur les donnees duo de la bonne capacite (prix, paires, stock). */
  function syncDuoGroup() {
    if (!duoGroups || !duoData) return;
    var id = currentVariantId();
    if (!id || duoData.options.some(function (o) { return String(o.v) === id; })) return;
    Object.keys(duoGroups).some(function (k) {
      var g = duoGroups[k];
      if (g && g.options && g.options.some(function (o) { return String(o.v) === id; })) {
        duoData = g; duoColor2 = null; duoColor2Manual = false; return true;
      }
      return false;
    });
  }
  function defaultColor2(cur) {
    var same = duoVariantFor(cur);
    if (!same || same.available) return cur;
    var alt = duoData.options.find(function (o) { var r = duoVariantFor(o.l); return !!(r && r.available); });
    return alt ? alt.l : cur;
  }
  function ensureColor2() {
    syncDuoGroup();
    if (!duoData) return;
    var cur = currentLabel();
    if (!duoColor2Manual) { duoColor2 = defaultColor2(cur); return; }
    var still = duoData.options.some(function (o) { return o.l === duoColor2; });
    if (!still) { duoColor2 = cur; duoColor2Manual = false; }
  }
  function setImgs(sel, url) {
    if (!url) return;
    x2.querySelectorAll('[data-tp-x2-img="' + sel + '"]').forEach(function (img) { if (img.getAttribute('src') !== url) img.setAttribute('src', url); });
  }

  function refreshX2() {
    if (!x2) return;
    var full = currentPriceCents * 2;
    var two = x2.querySelector('[data-tp-x2-qty][value="2"]');
    var one = x2.querySelector('[data-tp-x2-qty][value="1"]');
    renderPrice(x2.querySelector('[data-tp-x2-price="1"]'), currentPriceCents, 'tp-price--compact');
    renderPrice(x2.querySelector('[data-tp-x2-full]'), full, 'tp-price--old');
    if (x2Mode === 'duo') ensureColor2();
    var offer = currentOffer();
    if (offer) {
      renderPrice(x2.querySelector('[data-tp-x2-price="2"]'), offer.price, 'tp-price--compact');
      renderPrice(x2.querySelector('[data-tp-x2-save]'), full - offer.price, 'tp-price--compact');
      x2.dataset.packVariant = String(offer.id);
      /* Prix du lot coche, lu par l'encart VIP (toudoupet-vip-price) pour
         annoncer le prix VIP20 du lot : aucune valeur stockee ailleurs. */
      x2.dataset.packCents = String(offer.price);
      x2.classList.remove('is-unavailable');
      if (two) two.disabled = false;
      if (duoError) duoError.hidden = true;
    } else {
      x2.dataset.packVariant = '';
      x2.dataset.packCents = '';
      x2.classList.add('is-unavailable');
      if (two) { two.checked = false; two.disabled = true; }
      if (one) one.checked = true;
      if (duoError) duoError.hidden = x2Mode !== 'duo';
    }
    /* Exemplaire 1 (miniature « 1 unite » + avant du duo) = variante courante ;
       exemplaire 2 (arriere du duo) = couleur choisie. */
    var url1 = x2Images[currentVariantId()];
    var url2 = url1;
    if (x2Mode === 'duo' && duoColor2 && duoData) {
      var o2 = duoData.options.find(function (o) { return o.l === duoColor2; });
      if (o2 && x2Images[String(o2.v)]) url2 = x2Images[String(o2.v)];
    }
    setImgs('1', url1);
    setImgs('2', url2);
    if (x2Mode === 'duo') { renderSwatches(); if (duoPicker) duoPicker.hidden = !packSelected(); }
    /* P3.1 : le selecteur de quantite reste visible (il affiche les unites). */
  }

  if (x2) {
    x2.addEventListener('change', function (e) {
      var r = e.target.closest('[data-tp-x2-qty]');
      if (!r) return;
      /* P3.1 : la quantite affichee suit l'offre choisie sur la carte. */
      if (qtyInput) { if (r.value === '2') qtyInput.value = 2; else if (qtyValue() === 2) qtyInput.value = 1; }
      setAutoNote(false);
      refreshX2();
      updateLiveTotal(false);
      /* Signal pour l'encart VIP (toudoupet-vip-price) : prix VIP20 du lot coche s'il est eligible. */
      x2.dispatchEvent(new CustomEvent('tp:offerchange', { bubbles: true, detail: { source: 'x2' } }));
    });
    x2.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-tp-x2-color]');
      if (!sw || sw.classList.contains('is-unavailable')) return;
      duoColor2 = sw.dataset.tpX2Color;
      duoColor2Manual = true;
      refreshX2();
      updateLiveTotal(false);
    });
    x2.addEventListener('keydown', function (e) {
      var sw = e.target.closest('[data-tp-x2-color]');
      if (!sw || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault(); sw.click();
    });
  }

  var buyButtons = [addBtn, miniAddBtn, stickyBtn].filter(Boolean);
  buyButtons.forEach(function (btn) { var icon = btn.querySelector('span[aria-hidden]'); btn.dataset.tpIcon = icon ? icon.outerHTML : ''; btn.dataset.tpAvail = btn.disabled ? '0' : '1'; });
  function idleMarkup(btn) { var available = btn.dataset.tpAvail !== '0'; var label = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout; return escapeHtml(label) + (btn.dataset.tpIcon ? ' ' + btn.dataset.tpIcon : ''); }
  /* Pendant l'envoi et l'etat « Ajoute », le bouton est inactif via aria-disabled
     (pas disabled) : il garde le focus clavier, rendu ensuite par le drawer (D3). */
  function toIdle(btn) { btn.classList.remove('is-success', 'is-error', 'is-busy'); btn.innerHTML = idleMarkup(btn); btn.removeAttribute('aria-disabled'); btn.disabled = btn.dataset.tpAvail === '0'; btn.setAttribute('aria-busy', 'false'); btn.dataset.tpState = 'idle'; }
  function setAvailability(available) {
    buyButtons.forEach(function (btn) { btn.dataset.tpAvail = available ? '1' : '0'; if (btn.dataset.tpState === 'busy' || btn.dataset.tpState === 'success') return; toIdle(btn); });
    buyNowAvail = available;
    if (buyNowBtn && buyNowBtn.dataset.tpState !== 'busy') buyNowBtn.disabled = !available;
  }
  function setBusy(btn) { if (!btn) return; btn.dataset.tpState = 'busy'; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-disabled', 'true'); }
  function setSuccess(btn) {
    if (!btn) return;
    btn.dataset.tpState = 'success'; btn.classList.remove('is-busy', 'is-error'); btn.classList.add('is-success'); btn.setAttribute('aria-busy', 'false');
    btn.innerHTML = '<span class="tp-btn-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' + escapeHtml(btn.dataset.labelAdded || 'Ajouté');
    btn.setAttribute('aria-disabled', 'true');
    window.setTimeout(function () { toIdle(btn); }, reduceMotion ? 600 : 850);
  }
  function setError(btn, message) {
    if (!btn) return;
    btn.dataset.tpState = 'error'; btn.classList.remove('is-busy', 'is-success'); btn.classList.add('is-error'); btn.setAttribute('aria-busy', 'false');
    btn.textContent = btn.dataset.labelError || 'Impossible d’ajouter — réessayer'; btn.removeAttribute('aria-disabled'); btn.disabled = false;
    announce(message || btn.dataset.labelError || 'L’ajout au panier a échoué.');
    window.setTimeout(function () { if (btn.dataset.tpState === 'error') toIdle(btn); }, 2200);
  }
  /* Prix de reference barre a cote du prix courant : valeur des articles
     achetes separement (entry.ref, en centimes), jamais un ancien prix.
     Masque s'il n'y en a pas, et jamais affiche quand un compare_at est deja
     barre dans la ligne de prix -> une seule reference par offre. */
  function setPriceRef(entry) {
    var refEl = document.getElementById('tpBuyBoxPriceRef');
    if (!refEl) return;
    var refValueEl = document.getElementById('tpBuyBoxPriceRefValue');
    var refCents = entry && entry.ref ? parseInt(entry.ref, 10) : 0;
    var show = refCents > 0 && !section.querySelector('.tp-buy-box__price-old');
    if (show && refValueEl) renderPrice(refValueEl, refCents, 'tp-price--old');
    /* Trait anime (.tp-price-ref--strike) : rejoue une fois quand le prix
       separe affiche change ; bascule de classe = autre nom d'animation CSS. */
    var prevCents = parseInt(refEl.getAttribute('data-ref-cents'), 10) || 0;
    if (show && refCents !== prevCents) refEl.classList.toggle('is-restrike');
    refEl.setAttribute('data-ref-cents', String(show ? refCents : 0));
    refEl.hidden = !show;
  }
  function setSavingsFor(variantId, compareCents, priceCents) {
    /* Elements relus a chaque appel : la buybox peut avoir ete rendue sur une
       variante sans economie (le conteneur est alors present mais masque).
       entry.note porte la sous-ligne complete, deja redigee par le moteur. */
    var valueEl = document.getElementById('tpBuyBoxValue');
    var savingsEl = document.getElementById('tpBuyBoxSavings');
    var savingsTextEl = document.getElementById('tpBuyBoxSavingsText');
    var savingsSep = document.getElementById('tpBuyBoxValueSep');
    var entry = readSavingsMap()[String(variantId)]; var text = '';
    setPriceRef(entry);
    if (!savingsEl) return;
    if (entry && entry.note) text = entry.note;
    else if (compareCents && priceCents && compareCents > priceCents) text = 'Économisez ' + priceText(compareCents - priceCents);
    savingsEl.hidden = !text; if (savingsSep) savingsSep.hidden = !text; if (savingsTextEl) savingsTextEl.textContent = text;
    if (valueEl) valueEl.hidden = !text && !valueEl.querySelector('.tp-buy-box__value-guide');
  }

  function visibleMedia() { if (!galleryMain) return []; return Array.prototype.filter.call(galleryMain.querySelectorAll('.tp-product-gallery__img'), function (el) { return !el.hidden; }); }
  /* Mobile (CSS <= 900 px) : galerie en scroll-snap horizontal ; ailleurs, fondu. */
  function gallerySnaps() { return !!galleryMain && String(getComputedStyle(galleryMain).scrollSnapType).indexOf('x') !== -1; }
  function showMedia(mediaId, fromScroll) {
    if (!galleryMain || !mediaId) return;
    var target = galleryMain.querySelector('[data-media-id="' + mediaId + '"]');
    if (!target || target.hidden) return;
    galleryMain.querySelectorAll('.tp-product-gallery__img').forEach(function (img) { img.classList.remove('is-active'); if (img.classList.contains('tp-product-gallery__img--video')) { var v = img.querySelector('video'); if (v && !v.paused) v.pause(); } });
    target.classList.add('is-active');
    if (target.classList.contains('tp-product-gallery__img--video')) { var video = target.querySelector('video'); if (video && video.dataset.poster && !video.getAttribute('poster')) { video.setAttribute('poster', video.dataset.poster); video.removeAttribute('data-poster'); } }
    if (galleryThumbs) galleryThumbs.querySelectorAll('.tp-product-gallery__thumb').forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId)); });
    if (!fromScroll && gallerySnaps()) galleryMain.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  function applyHero(heroId) {
    if (!galleryMain) return;
    var heroes = galleryMain.querySelectorAll('[data-tp-hero]');
    if (!heroes.length) { if (heroId) showMedia(heroId); return; }
    var wanted = heroId ? String(heroId) : '';
    var target = wanted ? galleryMain.querySelector('[data-tp-hero][data-media-id="' + wanted + '"]') : null;
    if (!target && defaultHeroId) target = galleryMain.querySelector('[data-media-id="' + defaultHeroId + '"]');
    if (!target) target = heroes[0];
    var targetId = target.dataset.mediaId;
    heroes.forEach(function (el) { el.hidden = el !== target; });
    if (target.hidden) target.hidden = false;
    if (galleryMain.firstElementChild !== target) galleryMain.prepend(target);
    if (galleryThumbs) {
      galleryThumbs.querySelectorAll('[data-tp-hero]').forEach(function (t) { t.hidden = t.dataset.mediaId !== targetId; });
      var thumb = galleryThumbs.querySelector('[data-media-id="' + targetId + '"]');
      if (thumb) { thumb.hidden = false; if (galleryThumbs.firstElementChild !== thumb) galleryThumbs.prepend(thumb); }
      if (!reduceMotion && galleryThumbs.scrollTo) galleryThumbs.scrollTo({ left: 0, behavior: 'smooth' });
    }
    showMedia(targetId);
  }
  function galleryStep(dir) { var imgs = visibleMedia(); if (imgs.length < 2) return; var idx = imgs.findIndex(function (i) { return i.classList.contains('is-active'); }); showMedia(imgs[(idx + dir + imgs.length) % imgs.length].dataset.mediaId); }
  if (galleryThumbs) galleryThumbs.addEventListener('click', function (e) { var thumb = e.target.closest('.tp-product-gallery__thumb'); if (thumb) showMedia(thumb.dataset.mediaId); });
  if (galleryPrev) galleryPrev.addEventListener('click', function () { galleryStep(-1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { galleryStep(1); });
  if (galleryMain) {
    galleryMain.addEventListener('click', function (e) { if (e.target.closest('.tp-product-gallery__img--video')) return; galleryMain.classList.toggle('is-zoomed'); });
    galleryMain.addEventListener('mousemove', function (e) { if (!galleryMain.classList.contains('is-zoomed')) return; var active = galleryMain.querySelector('.tp-product-gallery__img.is-active'); if (!active || active.classList.contains('tp-product-gallery__img--video')) return; var rect = galleryMain.getBoundingClientRect(); active.style.transformOrigin = ((e.clientX - rect.left) / rect.width) * 100 + '% ' + ((e.clientY - rect.top) / rect.height) * 100 + '%'; });
    galleryMain.addEventListener('mouseleave', function () { galleryMain.classList.remove('is-zoomed'); });
    /* Balayage mobile : une fois le defilement pose, le media le plus proche devient l'actif (miniatures, pause video, fin du zoom). */
    var galleryScrollTimer = 0;
    galleryMain.addEventListener('scroll', function () {
      window.clearTimeout(galleryScrollTimer);
      galleryScrollTimer = window.setTimeout(function () {
        if (!gallerySnaps()) return;
        var x = galleryMain.scrollLeft, best = null;
        visibleMedia().forEach(function (el) { if (!best || Math.abs(el.offsetLeft - x) < Math.abs(best.offsetLeft - x)) best = el; });
        if (best && !best.classList.contains('is-active')) { galleryMain.classList.remove('is-zoomed'); showMedia(best.dataset.mediaId, true); }
      }, 80);
    }, { passive: true });
  }

  var colorSelector = document.getElementById('tpColorSelector');
  var colorValue = document.getElementById('tpColorSelectorValue');
  if (colorSelector) {
    colorSelector.addEventListener('click', function (e) {
      var swatch = e.target.closest('.tp-color-selector__swatch');
      if (!swatch) return;
      colorSelector.querySelectorAll('.tp-color-selector__swatch').forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
      swatch.classList.add('is-active'); swatch.setAttribute('aria-pressed', 'true');
      if (colorValue) colorValue.textContent = swatch.dataset.value;
      /* Badge de variante (custom.badge_variante) porte par le swatch : affiche a cote de la valeur choisie. */
      var colorBadge = document.getElementById('tpColorSelectorBadge');
      if (colorBadge) { var sb = swatch.dataset.badge || ''; colorBadge.textContent = sb; colorBadge.hidden = !sb; }
      if (variantInput) variantInput.value = swatch.dataset.variantId;
      var priceCents = parseInt(swatch.dataset.priceCents, 10) || currentPriceCents;
      setSavingsFor(swatch.dataset.variantId, (parseInt(swatch.dataset.savingsCents, 10) || 0) + priceCents, priceCents);
      setAvailability(swatch.dataset.available === 'true');
      applyHero(colorHeroFor([swatch.dataset.value]) || swatch.dataset.mediaId);
      applyPrice(priceCents);
      announce(swatch.dataset.value + ', ' + priceText(priceCents) + (swatch.dataset.available === 'true' ? '' : ', épuisé'));
      section.dispatchEvent(new CustomEvent('tp:variantchange', { bubbles: true, detail: { variantId: swatch.dataset.variantId } }));
    });
  }

  var picker = document.getElementById('tpVariantPicker');
  var variantsJson = document.getElementById('tpVariantsJson');
  var variantStatus = document.getElementById('tpVariantStatus');
  if (picker && variantsJson) {
    var variants = [];
    try { variants = JSON.parse(variantsJson.textContent) || []; } catch (e) { variants = []; }
    function selectedValues() { return Array.prototype.map.call(picker.querySelectorAll('.tp-variant-picker__group'), function (group) { var active = group.querySelector('.tp-variant-picker__pill.is-active'); return active ? active.dataset.optionValue : null; }); }
    function findVariant(values) { return variants.find(function (v) { return v.options.every(function (opt, i) { return opt === values[i]; }); }); }
    /* Badges par variante (custom.badge_variante) : mapping { variantId: libelle }
       genere en Liquid (#tpVariantBadgesJson). A chaque changement, chaque pilule
       est re-associee a la variante exacte qu'elle produirait avec les autres
       options courantes, et son tag suit (ajoute / mis a jour / retire). Absent
       (produit sans badge de variante) -> aucun traitement, l'ancien tag statique
       (repli variante_recommandee) reste tel quel. */
    var variantBadges = {};
    try { var badgesNode = document.getElementById('tpVariantBadgesJson'); if (badgesNode) variantBadges = JSON.parse(badgesNode.textContent) || {}; } catch (e) { variantBadges = {}; }
    var hasVariantBadges = Object.keys(variantBadges).length > 0;
    function refreshPillBadge(pill, v) {
      var badge = (v && variantBadges[String(v.id)]) ? String(variantBadges[String(v.id)]) : '';
      var tag = pill.querySelector('[data-tp-variant-badge]');
      if (!badge) { if (tag) tag.remove(); return; }
      if (!tag) {
        tag = document.createElement('span'); tag.className = 'tp-variant-picker__tag'; tag.setAttribute('data-tp-variant-badge', '');
        var saveTag = pill.querySelector('.tp-variant-picker__tag--save');
        if (saveTag) pill.insertBefore(tag, saveTag); else pill.appendChild(tag);
      }
      if (tag.textContent !== badge) tag.textContent = badge;
    }
    function refreshUnavailable(values) {
      picker.querySelectorAll('.tp-variant-picker__group').forEach(function (group, gi) {
        group.querySelectorAll('.tp-variant-picker__pill').forEach(function (pill) { var probe = values.slice(); probe[gi] = pill.dataset.optionValue; var v = findVariant(probe); var off = !v || !v.available; pill.classList.toggle('is-unavailable', off); if (hasVariantBadges) refreshPillBadge(pill, v); refreshPillSoldOut(pill, off); });
      });
    }
    /* Indisponibilite lue aussi par les lecteurs d'ecran (le texte barre n'est qu'un indice visuel) : texte cache en fin de pilule. */
    function refreshPillSoldOut(pill, off) {
      var hint = pill.querySelector('[data-tp-soldout]');
      if (!off) { if (hint) hint.remove(); return; }
      if (!hint) { hint = document.createElement('span'); hint.className = 'tp-visually-hidden'; hint.setAttribute('data-tp-soldout', ''); hint.textContent = ' — épuisé'; }
      if (pill.lastChild !== hint) pill.appendChild(hint);
    }
    function activeLabels() { return Array.prototype.map.call(picker.querySelectorAll('.tp-variant-picker__group:not([hidden]) .tp-variant-picker__pill.is-active'), function (p) { return p.dataset.optionLabel || p.dataset.optionValue; }).join(' / '); }
    function applyVariant() {
      var values = selectedValues();
      var v = findVariant(values);
      var colorHero = colorHeroFor(values);
      refreshUnavailable(values);
      if (!v) { setAvailability(false); if (variantStatus) variantStatus.hidden = false; if (colorHero) applyHero(colorHero); return; }
      if (variantInput) variantInput.value = v.id;
      setSavingsFor(v.id, v.compare_at_price, v.price);
      setAvailability(!!v.available);
      if (variantStatus) variantStatus.hidden = !!v.available;
      applyHero(colorHero || (v.featured_media && v.featured_media.id ? v.featured_media.id : ''));
      applyPrice(v.price);
      announce(activeLabels() + ', ' + priceText(v.price) + (v.available ? '' : ', épuisé'));
      section.dispatchEvent(new CustomEvent('tp:variantchange', { bubbles: true, detail: { variantId: v.id, options: v.options } }));
    }
    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('.tp-variant-picker__pill');
      if (!pill) return;
      var group = pill.closest('.tp-variant-picker__group');
      group.querySelectorAll('.tp-variant-picker__pill').forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-active'); pill.setAttribute('aria-pressed', 'true');
      var label = group.querySelector('[data-option-value-label]');
      if (label) label.textContent = pill.dataset.optionLabel || pill.textContent.trim();
      applyVariant();
    });
    refreshUnavailable(selectedValues());
    var initialHero = colorHeroFor(selectedValues());
    if (initialHero) applyHero(initialHero);
  }

  /* P3.1 : chaque changement de quantite resynchronise l'offre (2 -> Pack de 2,
     3 -> Pack de 3 si disponible, sinon unites au prix unitaire). */
  if (qtyMinus) qtyMinus.addEventListener('click', function () { var v = parseInt(qtyInput.value, 10) || 1; if (v > 1) { qtyInput.value = v - 1; syncOfferToQty(true); updateLiveTotal(false); } });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { var v = parseInt(qtyInput.value, 10) || 1; qtyInput.value = v + 1; syncOfferToQty(true); updateLiveTotal(false); });
  if (qtyInput) {
    qtyInput.addEventListener('input', function () { if (parseInt(qtyInput.value, 10) >= 1) { syncOfferToQty(true); updateLiveTotal(false); } });
    qtyInput.addEventListener('change', function () { normalizeQty(); syncOfferToQty(true); updateLiveTotal(false); });
  }

  function collectSelectedItems() {
    normalizeQty();
    /* P3.1 : derniere resynchronisation avant envoi (evenements synchrones). */
    syncOfferToQty(false);
    var qty = qtyValue();
    var main;
    var x2Offer = packSelected() ? currentOffer() : null;
    var tOffer = trioOffer();
    if (x2Offer) {
      /* Pack de 2 : UNE variante bundle Shopify (2 exemplaires) -> quantite 1. */
      if (qty !== 2) throw new Error('Quantité incohérente avec le pack. Merci de réessayer.');
      main = { id: x2Offer.id, quantity: 1 };
    } else if (tOffer) {
      /* Trio : toudoupet-offer-trio.js a ecrit l'ID bundle (2 ou 3 exemplaires). */
      if (qty !== tOffer.units) throw new Error('Quantité incohérente avec le pack. Merci de réessayer.');
      main = { id: parseInt(variantInput.value, 10), quantity: 1 };
    } else {
      main = { id: parseInt(variantInput.value, 10), quantity: qty };
    }
    var items = [main];
    section.querySelectorAll('[data-tp-supp-input]').forEach(function (input) { if (input.checked) items.push({ id: parseInt(input.value, 10), quantity: 1 }); });
    return items;
  }

  function addToCart(items, btn) {
    if (btn && (btn.dataset.tpState === 'busy' || btn.dataset.tpState === 'success')) return;
    setBusy(btn);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { return res.json().then(function (data) { if (!res.ok) throw new Error(data && data.description ? data.description : ''); return data; }); })
      .then(function () {
        setSuccess(btn); announce('Ajouté au panier.');
        section.querySelectorAll('[data-tp-supp-input]').forEach(function (i) { i.checked = false; });
        if (window.ToudouCart) { if (window.ToudouCart.refreshCartDrawer) window.ToudouCart.refreshCartDrawer().catch(function () {}); if (window.ToudouCart.openCartDrawer) window.setTimeout(function () { window.ToudouCart.openCartDrawer(btn); }, reduceMotion ? 0 : 250); }
      })
      .catch(function (err) { setError(btn, err && err.message ? err.message : ''); });
  }
  function handleAdd(btn) { if (!variantInput || !btn || btn.disabled) return; var items; try { items = collectSelectedItems(); } catch (err) { setError(btn, err && err.message ? err.message : ''); return; } addToCart(items, btn); }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); handleAdd(addBtn); }, true);
  if (miniAddBtn) miniAddBtn.addEventListener('click', function () { handleAdd(miniAddBtn); });
  if (stickyBtn) stickyBtn.addEventListener('click', function () { handleAdd(stickyBtn); });

  /* « Acheter maintenant » : un seul envoi par clic (verrou d'etat, comme
     addToCart) ; pendant l'envoi et la redirection le bouton reste focusable
     mais inactif (aria-disabled) et affiche le libelle de chargement. */
  function buyNowIdle() {
    buyNowBtn.dataset.tpState = 'idle';
    buyNowBtn.classList.remove('is-loading');
    buyNowBtn.setAttribute('aria-busy', 'false');
    buyNowBtn.removeAttribute('aria-disabled');
    buyNowBtn.textContent = buyNowBtn.dataset.label;
    buyNowBtn.disabled = !buyNowAvail;
  }
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      if (buyNowBtn.disabled || buyNowBtn.dataset.tpState === 'busy') return;

      buyNowBtn.dataset.tpState = 'busy';
      buyNowBtn.classList.add('is-loading');
      buyNowBtn.setAttribute('aria-busy', 'true');
      buyNowBtn.setAttribute('aria-disabled', 'true');
      buyNowBtn.textContent = buyNowBtn.dataset.labelLoading;

      if (buyNowError) buyNowError.hidden = true;

      /* P3.1 : lignes calculees avant l'envoi ; incoherence -> message, aucun ajout. */
      var tpBuyItems;
      try { tpBuyItems = collectSelectedItems(); } catch (err) {
        buyNowIdle();
        if (buyNowError) { buyNowError.textContent = err && err.message ? err.message : buyNowBtn.dataset.labelError; buyNowError.hidden = false; }
        return;
      }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: tpBuyItems })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-failed');

          return window.ToudouCart && window.ToudouCart.syncShippingDiscount
            ? window.ToudouCart.syncShippingDiscount()
            : null;
        })
        .then(function () {
          if (window.tpVipGuardGo) { window.tpVipGuardGo(); } else { window.location.href = root + 'checkout'; }
        })
        .catch(function () {
          buyNowIdle();

          if (buyNowError) {
            buyNowError.textContent = buyNowBtn.dataset.labelError;
            buyNowError.hidden = false;
          }
        });
    });
    /* Retour arriere depuis le checkout (page restauree depuis le cache) : bouton remis a l'etat initial. */
    window.addEventListener('pageshow', function (e) { if (e.persisted && buyNowBtn.dataset.tpState === 'busy') buyNowIdle(); });
  }

  /* Offre trio : nouvel etat publie par toudoupet-offer-trio.js -> total et barre mobile. */
  section.addEventListener('tp:offerchange', function (e) {
    if (!trio || !e.detail || e.detail.source !== 'trio') return;
    /* Etat deja affiche ? (lu AVANT la resynchronisation : trioOffer() met trioKey a jour). */
    var sameTrio = (trio.dataset.offerUnits || '') + ':' + (trio.dataset.offerCents || '') === trioKey;
    /* P3.1 : une offre redevenue disponible (autre couleur) suit a nouveau la quantite. */
    if (!trio.dataset.tpSyncing) syncOfferToQty(false);
    if (sameTrio) return;
    updateLiveTotal(false);
  });

  /* URL partageable (D11) : ?variant= suit la variante choisie par le client
     (couleur / taille / capacite = celle de tp:variantchange), jamais l'ID d'un
     pack x2 / trio (variante bundle masquee, que le Liquid ne preselectionne
     pas). history.replaceState : ni rechargement ni nouvelle entree
     d'historique ; seule la valeur de variant est remplacee ou ajoutee, les
     autres parametres (UTM...) et l'ancre restent tels quels. Rien au
     chargement : une URL d'arrivee (meme sur une variante masquee) est conservee. */
  function syncVariantUrl(id) {
    if (!id || !window.history || typeof window.history.replaceState !== 'function') return;
    var search = window.location.search, re = /([?&])variant=[^&]*/;
    var next = re.test(search) ? search.replace(re, '$1variant=' + encodeURIComponent(id)) : (search ? search + '&' : '?') + 'variant=' + encodeURIComponent(id);
    if (next === search) return;
    try { window.history.replaceState(window.history.state, '', window.location.pathname + next + window.location.hash); } catch (e) {}
  }
  section.addEventListener('tp:variantchange', function (e) { if (e.detail && e.detail.variantId) syncVariantUrl(String(e.detail.variantId)); });

  /* Barre d'achat mobile : visible des que le bouton « Ajouter au panier » est hors ecran,
     qu'il soit encore plus bas (descente de la fiche) ou deja depasse ; masquee quand il est visible. */
  if (stickyBar && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { entries.forEach(function (entry) { stickyBar.classList.toggle('is-visible', !entry.isIntersecting); }); }, { threshold: 0 }).observe(addBtn);
  }
  document.querySelectorAll('.tp-pdp-accordion__question').forEach(function (btn) { btn.addEventListener('click', function () { var item = btn.closest('.tp-pdp-accordion__item'); var open = item.classList.toggle('is-open'); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }); });

  refreshX2();
  /* P3.1 : etat initial (y compris formulaire restaure par le navigateur au
     retour arriere / actualisation) : une offre cochee impose ses unites a la
     quantite affichee ; sinon l'offre suit la quantite. */
  (function () {
    var o = activeOffer();
    if (o && qtyInput) qtyInput.value = o.units; else syncOfferToQty(false);
  })();
  updateLiveTotal(false);
})();